import type { FaireProductEntity } from "../../entity_types/product";

export const p_k63p2r77ka: FaireProductEntity = {
  token: "p_k63p2r77ka",
  type: "product",
  name: "50mL Perfume - Bosque Místico",
  brandToken: "b_c3hepkjc1t",
  brandName: "Nopalera",
  imageUrl:
    "https://cdn.faire.com/fastly/1618166dde38754f57692881a20b111002a6f9fae9cc8e93ebd58c08448351a2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e77800ec088cf38969ddb941a80ba2fdffd2d62eb0b416a88d03d706cc9347a7.jpeg",
    "https://cdn.faire.com/fastly/e8aed2bf2f6886af495cab3e0b8c06995602915258e642b134d29b0f10c22bd7.jpeg",
    "https://cdn.faire.com/fastly/310d973e9977ca9e9583c9d8400685cc6f6c9ebb1ac4706c88138902aba7e63c.jpeg",
    "https://cdn.faire.com/fastly/d16845a6108eca9e002ebb74a0b87fe57ec6376c1a9ecf6a2f0466da928be8a6.jpeg",
    "https://cdn.faire.com/fastly/b60dae1a982b5c81259ed37ce9d198398327f6bc66c93f7dd78372ec0afc874b.jpeg",
  ],
  priceDollars: 39,
  description:
    "Sweet and inviting, Bosque Místico eau de parfum captures the allure of Mexico’s mystical forests with notes of sweet hibiscus, spicy pepper, and vibrant citrus zest. Honeysuckle and orris bloom at its heart, while cashmere woods wrap you in a cozy embrace. The perfect scent for tender days and nights.\n\nTOP: Hibiscus, Pepper, Citrus Zest\nMID: Honeysuckle, Orris\nBASE: Cashmere Woods\n\nClean formulation with no phthalates, parabens or sulfates\nVegan | Cruelty free | Gluten free\n\nInstructions for use: Spray on pulse points, where  skin is naturally warmer. These areas include the wrists, behind the ears, the inner elbows. The warmth will help to release the fragrance throughout the day. Keep your perfume in a cool, dry place away from direct sunlight and heat to preserve its integrity and longevity.\n\nhttps://nopalera.co/blogs/news/why-clean-fragrance-is-better-for-your-health\n\n\nWe are a clean brand. Our products are vegan and free from hormone disruptors and phthalates.",
  tags: [],
  msrpDollars: 78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:20:52.469Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
